import { DetailedHTMLProps, FC, FormHTMLAttributes } from 'react';
import cn from 'classnames';

import { useAuthPageWrapperContext } from '../AuthPageWrapperContext';

export const Form: FC<
  DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>
> = ({ children, className, ...props }) => {
  const { cnBem } = useAuthPageWrapperContext();

  return (
    <form className={cn(cnBem('__form'), className)} {...props}>
      {children}
    </form>
  );
};
